import React from 'react';
import { stringify } from 'querystring';

import { formatAddress } from '@evdy/web-core/dist/lib/utils';

import { GMAPS_API_KEY, GMAPS_URL } from '@evdy/web-redux/dist/constants';

import mapPinIcon from '../../../public/images/CardElements/Map_Pin.svg';

import styles from './MapRow.module.scss';

const {
  'map-row': mapRowClass,
  'row-img': rowImgClass,
  'row-address': rowAddressClass,
  'row-map-container': rowMapContainer
} = styles;

const MapRow = ({ address }) => {
  const { street, city, state } = address;
  const center = `${street}+${city}+${state}`.replace(/ /g, '+');

  const query = stringify({
    zoom: 14,
    key: GMAPS_API_KEY,
    center,
    markers: null,
    size: '120x120',
    style: 'feature:poi|visibility:off'
  });

  return (
    <div className={mapRowClass}>
      <img className={rowImgClass} src={mapPinIcon} alt="map pin decoration" />
      <div className={rowAddressClass}>{formatAddress(address)}</div>
      <div className={rowMapContainer}>
        <img src={`${GMAPS_URL}?${query}`} alt="map to address" />
      </div>
    </div>
  );
};

export default MapRow;
